import { TailwindColorOrString, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import { StatusOption } from '../../utils'

export enum StatusEnum {
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED'
}

export const statusEnumMapping: Record<
  StatusEnum,
  StatusOption & { iconColor: TailwindColorOrString }
> = {
  [StatusEnum.PENDING]: {
    label: 'En attente',
    variant: 'blue',
    iconColor: tailwindColors.blue.DEFAULT
  },
  [StatusEnum.SUCCEEDED]: {
    label: 'Succès',
    variant: 'success',
    iconColor: tailwindColors.green.DEFAULT
  },
  [StatusEnum.FAILED]: {
    label: 'Échec',
    variant: 'danger',
    iconColor: tailwindColors.red.DEFAULT
  },
  [StatusEnum.CANCELLED]: {
    label: 'Annulé',
    variant: 'warning',
    iconColor: tailwindColors.yellow.DEFAULT
  }
}
